import Choices from 'choices.js';

import loadScript from '../functions/script-loader.js';
import loadStyleSheet from '../functions/styles-loader.js';


export const filteredEventsFeed = () => {

	let filteredEventsFeedModules = document.querySelectorAll('.m__filtered-events-feed');

	let hasLoadedjQueryAlready = false;


	if (filteredEventsFeedModules) {
		filteredEventsFeedModules.forEach((module) => {
			const dateFilterEl = module.querySelector('#dateFilter'),
			locationFilterEl = module.querySelector('#locationFilter'),
			resetFilters = module.querySelectorAll('.js__reset-filters');

			// Get the event card container
			let cardContainer = module.querySelector('.js__cards');
			
			let dateFilterStartDate	= 0,
				dateFilterEndDate   = 0;


			if (dateFilterEl && locationFilterEl) {

				// Init nice styled dropdown
				const choicesConfig = {
					itemSelectText: '',
					shouldSort: false,
					searchEnabled: false,
				},
				locationFilter = new Choices(locationFilterEl,choicesConfig);

				// Init nice datepicker
				if (!hasLoadedjQueryAlready) {
					// Dynamically load in jQuery, and daterangepicker. All shamelessly taken from Drake & Morgan
					loadScript('https://cdn.jsdelivr.net/jquery/latest/jquery.min.js',() => {
						loadScript('https://cdn.jsdelivr.net/momentjs/latest/moment.min.js',() => {
							loadScript('https://cdn.jsdelivr.net/npm/daterangepicker/daterangepicker.min.js',() => {
								loadStyleSheet('https://cdn.jsdelivr.net/npm/daterangepicker/daterangepicker.css').then(() =>{
									// Activate DateRangePicker
									var date = new Date();
									var d = date.getDate();
									var m = date.getMonth()+1;
									var y = date.getFullYear();
									var y2 = y + 2;
									var mindate = d+'/'+m+'/'+y;
									var maxdate = d+'/'+m+'/'+y2;
									
									$('#dateFilter').daterangepicker({
										opens: 'left',
										autoUpdateInput: false,
										minDate: mindate,
										maxDate: maxdate,
										ranges: {
									      'This Week': [moment().startOf('week'), moment().endOf('week').add(1, 'days')],
									      'This Month': [moment().startOf('month'), moment().endOf('month')],
									  },
									  alwaysShowCalendars: true,
										locale: {
									    format: 'DD/MM/YYYY'
									  }
									}, (start, end, label) => { // On select event
										// Update element with selected dates
										dateFilterEl.value = (start.format('DD/MM/YYYY') + ' - ' + end.format('DD/MM/YYYY'));

										dateFilterStartDate = start.unix();
										dateFilterEndDate   = end.unix();
 
										dateFilterEl.dispatchEvent(new Event('change'));
									} ); 
								})
							})
						})
					})
				}


				// Select elements for us to watch for changes
				let filterInputs = [
					dateFilterEl,
					locationFilterEl
				];
				filterInputs.forEach((filterInput) => {
					filterInput.addEventListener("change", (event) => {
						let currentDateFilter = dateFilterEl.value,
							currentLocationFilter = locationFilterEl.value;
										
						getFilteredEvents(dateFilterStartDate, dateFilterEndDate, currentLocationFilter, cardContainer);
	
						//Manage reset filters button state
						if (currentLocationFilter != 0 || currentDateFilter > '') {
							resetFilters.forEach((resetFilter)=> {
								resetFilter.classList.remove('active');
							});
						} else {
							resetFilters.forEach((resetFilter)=> {
								resetFilter.classList.add('active');
							});
						}
					});
				});

				//Add listeners for any clicks on a reset filter class
				resetFilters.forEach((resetFilter)=> {
					resetFilter.addEventListener('click', (event) => {

						dateFilterStartDate	= 0,
						dateFilterEndDate   = 0;
						locationFilter.setChoiceByValue('0');
						getFilteredEvents(dateFilterStartDate, dateFilterEndDate, [], cardContainer);
					})
				});
			}
		});
	}
}

function getFilteredEvents(startDate, endDate, filters, cardContainer) {
	let queryData = new FormData;

	queryData.append('action', 'ajaxGetFilteredEvents');
	queryData.append('startDate', startDate);
	queryData.append('endDate', endDate);
	queryData.append('filters', filters);

	fetch(igniteAjax.ajaxurl, {
		method: 'POST',
		body: queryData,
	})
	.then((response) => response.text())
	.then((data) => {
		cardContainer.innerHTML = data;
	})
	.catch((error) => {
		cardContainer.innerHTML = '<p class="font-title text-grey text-3xl">An error occured, please refresh the page</p>';
		console.error(error);
	});
}